module.exports = __webpack_public_path__ + "static/media/filter-icon.ee1c7c95.png";